module.exports = [
    {
        "title": "法律法规",
        "contents": [
            {
                "link": "中华人民共和国电子签名法",
                "href": "http://www.miit.gov.cn/n1146285/n1146352/n3054355/n3057254/n3057259/c3868973/content.html"
            },
            {
                "link": "关于促进互联网金融健康发展的指导意见",
                "href": "http://www.gov.cn/xinwen/2015-07/18/content_2899360.htm"
            },
            {
                "link": "中国银监会办公厅关于印发网络借贷资金存管业务指引的通知",
                "href": "http://www.cbrc.gov.cn/govView_4201EF03472544038242EED1878597CB.html"
            },
            {
                "link": "最高人民法院关于审理民间借贷案件适用法律若干问题的规定",
                "href": "http://www.court.gov.cn/zixun-xiangqing-15146.html"
            },
            {
                "link": "贷款通则",
                "href": "http://www.cbrc.gov.cn/chinese/home/docDOC_ReadView/275.html"
            },
            {
                "link": "网络借贷信息中介机构业务活动管理暂行办法（银监会令[2016]1号）",
                "href": "http://www.cbrc.gov.cn/govView_37D312933F1A4CECBC18F9A96293F450.html"
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/config/InfoDcs/Regulations.js